import { render, staticRenderFns } from "./fxServiceNumTable.vue?vue&type=template&id=48d0190a"
import script from "./fxServiceNumTable.vue?vue&type=script&lang=js"
export * from "./fxServiceNumTable.vue?vue&type=script&lang=js"
import style0 from "./fxServiceNumTable.vue?vue&type=style&index=0&id=48d0190a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports